module.exports = __webpack_public_path__ + "static/img/M-2.6a57945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/M-2.png
// module id = k/lz
// module chunks = 0